import React from 'react';
import TopNav from '../../components/TopNav';
import Footer from '../../components/Footer';
import CatchImage from '../../images/catch/catch_law.jpg';
import CatchImage2x from '../../images/catch/catch_law@2x.jpg';
import { useTitle } from '../../hooks/useTitle';
import { useMetaDescription } from '../../hooks/useMetaDescription';

const CommercePage: React.FC = () => {
  useTitle('Ton Bébé | 特定商取引法に基づく表記');
  useMetaDescription('Ton Bébéの特定商取引法に基づく表記です。運営者情報や連絡先などを掲載しています。');

  return (
    <>
      <header>
        <TopNav />
        <div className="catch sub">
          <img
            src={ CatchImage }
            srcSet={ `${ CatchImage } 1x, ${ CatchImage2x } 2x` }
            alt="特定商取引法に基づく表記"
          />
        </div>
      </header>
      <main className="sub">
        <section className="law">
          <h1 className="sec_title">特定商取引法に基づく表記</h1>
          <ul className="text_list">
            <li>
              <h2 className="main_title"><span>サービス名</span></h2>
              <p>Ton Bébé （トンべべ）</p>
            </li>
            <li>
              <h2 className="main_title"><span>運営責任者</span></h2>
              <p>柿本 玄</p>
            </li>
            <li>
              <h2 className="main_title"><span>サイトURL</span></h2>
              <p>https://www.tonbebe.jp</p>
            </li>
            <li>
              <h2 className="main_title"><span>Email</span></h2>
              <p>info@tonbebe.jp</p>
            </li>
            <li>
              <h2 className="main_title"><span>販売価格</span></h2>
              <p>サービスの該当ページに記載</p>
            </li>
            <li>
              <h2 className="main_title"><span>送料</span></h2>
              <p>なし</p>
            </li>
            <li>
              <h2 className="main_title"><span>お支払い方法</span></h2>
              <p>クレジットカード</p>
            </li>
            <li>
              <h2 className="main_title"><span>商品代金以外の必要経費</span></h2>
              <p>なし</p>
            </li>
            <li>
              <h2 className="main_title"><span>商品引き渡し時期・方法</span></h2>
              <p>入金確認および弊社にて提出資料の審査が完了した後、ドナー一覧に表示されます。</p>
            </li>
            <li>
              <h2 className="main_title"><span>返品・返金について</span></h2>
              <p>申し込み後・決済後の返品・交換には応じられません。</p>
            </li>
          </ul>
          <p>※上記以外の事項に関しましては、お取引の際に請求があれば遅延なく提示いたします。</p>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default CommercePage;
